import React from 'react';

const StatisticsPanel = ({ stats }) => {
  const getClassLevelDistribution = () => {
    const distribution = {};
    for (let i = 1; i <= 6; i++) {
      distribution[`中${i}`] = stats.classLevels?.filter(level => level === i).length || 0;
    }
    return distribution;
  };

  const classLevelDistribution = getClassLevelDistribution();

  return (
    <div className="statistics-panel">
      <div className="stats-header">
        <h3>📊 統計面板</h3>
        <p>系統整體概況</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">🏫</div>
          <div className="stat-content">
            <h4>班級統計</h4>
            <div className="stat-number">{stats.totalClasses}</div>
            <p>總班級數</p>
            <div className="stat-details">
              <span className="detail-item">
                選修班級: {stats.electiveClasses}
              </span>
            </div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">👨‍🏫</div>
          <div className="stat-content">
            <h4>教師統計</h4>
            <div className="stat-number">{stats.totalTeachers}</div>
            <p>總教師數</p>
            <div className="stat-details">
              <span className="detail-item">
                任教科目: {stats.subjects?.length || 0}
              </span>
            </div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">👨‍🎓</div>
          <div className="stat-content">
            <h4>學生統計</h4>
            <div className="stat-number">{stats.totalStudents}</div>
            <p>總學生數</p>
            <div className="stat-details">
              <span className="detail-item">
                選修學生: {stats.electiveStudents}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="detailed-stats">
        <div className="class-level-distribution">
          <h4>班級年級分布</h4>
          <div className="distribution-grid">
            {Object.entries(classLevelDistribution).map(([level, count]) => (
              <div key={level} className="distribution-item">
                <span className="level-name">{level}</span>
                <div className="level-bar">
                  <div 
                    className="level-fill" 
                    style={{ 
                      width: `${(count / Math.max(...Object.values(classLevelDistribution))) * 100}%` 
                    }}
                  ></div>
                </div>
                <span className="level-count">{count}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="subjects-overview">
          <h4>科目概覽</h4>
          <div className="subjects-list">
            {stats.subjects?.slice(0, 8).map((subject, index) => (
              <span key={index} className="subject-tag">
                {subject}
              </span>
            ))}
            {stats.subjects?.length > 8 && (
              <span className="subject-tag more">
                +{stats.subjects.length - 8} 更多
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="system-info">
        <div className="info-item">
          <span className="info-label">系統狀態:</span>
          <span className="info-value status-active">正常運行</span>
        </div>
        <div className="info-item">
          <span className="info-label">最後更新:</span>
          <span className="info-value">{new Date().toLocaleString('zh-TW')}</span>
        </div>
      </div>
    </div>
  );
};

export default StatisticsPanel;
